import m from "../../atoms/VSkeleton/VSkeleton.js";
import { defineComponent as n, resolveComponent as i, openBlock as t, createElementBlock as l, createBlock as o } from "vue";
import d from "../VFormDateAndTimeSlotPicker/VFormDateAndTimeSlotPicker.js";
import { _ as p } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../VFormDatepicker/VFormDatepicker.js";
import "../VFormField/VFormField.js";
import "../../../vee-validate.esm-c4518011.js";
import "../../../utils/htmlSanitizer.js";
import "../../atoms/VIcon/VIcon.js";
import "../../atoms/VIconButton/VIconButton.js";
import "../../atoms/VText/VText.js";
import "../../../utils/tailwindUnitsConverter.js";
import "../../../constants-69d32a0e.js";
import "../VFormTimeslotPicker/VFormTimeslotPicker.js";
import "../VFormRadioCheckbox/VFormRadioCheckbox.js";
import "../../atoms/VFormRadioCheckboxGroup/VFormRadioCheckboxGroup.js";
import "../../../composables/useSpacingClass.js";
import "../../../VHeadline.vue_vue_type_script_lang-186a5340.js";
import "../../../composables/useShowPriceDisclaimer.js";
import "../../../VState-9b477ed6.js";
import "../../atoms/VButton/VButton.js";
import "../../atoms/VSpinner/VSpinner.js";
import "../../atoms/VHTMLText/VHTMLText.js";
import "../../atoms/VLink/VLink.js";
import "../../../utils/isExternalUrl.js";
import "../../atoms/VSubtitle/VSubtitle.js";
import "../../../Spacing-695d3b19.js";
import "../../../VImage-b57fd9d1.js";
const s = n({
  name: "VDateAndTimeSlotPicker",
  components: { VFormDateAndTimeSlotPicker: d, VSkeleton: m },
  emits: [
    "change",
    "dateAndTimeSlotPicker:fetch-dates",
    "dateAndTimeSlotPicker:date-selected"
  ],
  props: {
    datesWithSlots: { type: Array, default: () => [] },
    datepickerId: { type: String, required: !0 },
    datepickerName: { type: String, required: !0 },
    datepickerLabel: { type: String, default: "Datum wählen" },
    timeSlotPickerName: { type: String, required: !0 },
    timeslotPickerLabel: { type: String, default: "Zeit wählen" },
    noTimeSlotTitle: { type: String, default: "Kein Termin verfügbar" },
    noTimeSlotDescription: {
      type: String,
      default: "Es sind leider keine Termine verfügbar. Bitte wähle einen anderen Tag aus."
    },
    timeslotValue: { type: String, required: !0 },
    validationRules: {
      type: Function,
      default: () => !0
    },
    router: {
      type: Object,
      required: !0,
      default: void 0
    }
  },
  mounted() {
    this.$emit("dateAndTimeSlotPicker:fetch-dates");
  },
  methods: {
    onChange(e) {
      this.$emit("change", e);
    },
    onDateChange(e) {
      this.$emit("dateAndTimeSlotPicker:date-selected", e);
    }
  }
}), c = { class: "tw-mt-4" };
function S(e, k, u, T, h, P) {
  const r = i("VFormDateAndTimeSlotPicker"), a = i("VSkeleton");
  return t(), l("div", c, [
    e.datesWithSlots.length ? (t(), o(r, {
      key: 0,
      timeslotValue: e.timeslotValue,
      datepickerId: e.datepickerId,
      datepickerName: e.datepickerName,
      timeSlotPickerName: e.timeSlotPickerName,
      datesWithSlots: e.datesWithSlots,
      timeslotPickerLabel: e.timeslotPickerLabel,
      datePickerLabel: e.datepickerLabel,
      noTimeSlotTitle: e.noTimeSlotTitle,
      noTimeSlotDescription: e.noTimeSlotDescription,
      "onDateAndTimeSlotPicker:dateSelected": e.onDateChange,
      "onDateAndTimeSlotPicker:timeslotSelected": e.onChange,
      "validation-rules": e.validationRules,
      router: e.router
    }, null, 8, ["timeslotValue", "datepickerId", "datepickerName", "timeSlotPickerName", "datesWithSlots", "timeslotPickerLabel", "datePickerLabel", "noTimeSlotTitle", "noTimeSlotDescription", "onDateAndTimeSlotPicker:dateSelected", "onDateAndTimeSlotPicker:timeslotSelected", "validation-rules", "router"])) : (t(), o(a, {
      key: 1,
      height: "315px",
      width: "100%"
    }))
  ]);
}
const J = /* @__PURE__ */ p(s, [["render", S]]);
export {
  J as default
};
